/**
 * Base DTO
 */
export abstract class BaseDto {
  id!: number;
  color?: string | null;
  createdAt?: Date;
  createdByUserId?: number | null;
  createdByUsername?: string | null;
  updatedAt?: Date | null;
  updatedByUserId?: number | null;
  updatedByUsername?: string | null;
  isExcludedFromReports?: boolean | null;
  isExcludedFromAggregators?: boolean | null;
}
